import { Component, OnInit } from '@angular/core';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';

@Component({
  selector: 'app-email-ecommerce',
  templateUrl: './email-ecommerce.component.html',
  styleUrls: ['./email-ecommerce.component.scss']
})

export class EmailEcommerceComponent implements OnInit {

  public breadCrumbItems!: Array<{}>;
  public ourCompanyName  : string=this.platformInviewService.getOurCompanyName();
  public year            : number=new Date().getFullYear();

  constructor(
    private platformInviewService: PlatformInviewService
  ) { }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Email' },
      { label: 'Ecommerce Action', active: true }
    ];
  }
  
  inView(ele:any){
    ele.scrollIntoView({behavior:"smooth", block:"start", inline:"start"})
  }  
}
